// extracted by mini-css-extract-plugin
export default {"preview-wrap":"PreviewPDF_preview-wrap__LHONk","pdf-document":"PreviewPDF_pdf-document__tqtdw","pdf-loading":"PreviewPDF_pdf-loading__6Q5sG"};